module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.8.0-139.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.8.0.md
// module id = 556
// module chunks = 233